var _defs, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEstrella(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 110.18 116.14",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#e2de00;stroke-width:0px;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M50.83,40.89c.85.28,1.76-.19,2.03-1.04l2.2-6.78,7.22,22.23c.22.67.84,1.12,1.54,1.12h23.36l-18.9,13.74c-.57.41-.8,1.14-.59,1.8l2.62,8.07c.63,1.95,3.72.99,3.07-1l-2.26-6.96,21.97-15.97c1.26-.89.59-2.94-.95-2.92h-27.16l-8.39-25.84c-.46-1.47-2.61-1.47-3.07,0l-3.74,11.51c-.28.85.19,1.76,1.04,2.03h0Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M75.96,86.94c-.64-1.99-3.72-.99-3.07,1l2.03,6.25-18.9-13.74c-.57-.41-1.33-.41-1.9,0l-18.9,13.74,7.22-22.23c.22-.66-.02-1.39-.59-1.8l-18.9-13.74h23.36c.7,0,1.32-.45,1.54-1.12l2.36-7.27c.28-.85-.19-1.76-1.04-2.03-.85-.28-1.76.19-2.03,1.04l-2,6.15h-27.16c-1.54-.02-2.21,2.03-.95,2.92l21.97,15.97-8.39,25.84c-.22.67.02,1.39.59,1.8.57.41,1.33.41,1.9,0l21.97-15.97,21.97,15.97c.63.41,1.27.41,1.9,0,.57-.41.8-1.14.59-1.8l-3.57-10.98Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M55.07,9.25c.89,0,1.61-.72,1.61-1.61V1.57c0-2.09-3.23-2.09-3.23,0v6.07c0,.89.72,1.61,1.61,1.61Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M8.88,52.86c.28-.85-.19-1.76-1.04-2.03l-5.77-1.88c-1.98-.65-2.98,2.42-1,3.07l5.77,1.88c.78.25,1.78-.24,2.03-1.04Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M85.87,107.59c-1.23-1.69-3.84.21-2.61,1.9l3.56,4.91c1.27,1.75,3.81-.25,2.61-1.9l-3.56-4.91Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M110.1,39.98c-.28-.85-1.19-1.31-2.03-1.04l-5.77,11.88c-1.96.64-.91,3.69,1,3.07l5.77-11.88c.85-.28,1.31-1.19,1.04-2.03h0Z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M55.07,94.52c-.89,0-1.61.72-1.61,1.61v18.44c0,2.09,3.23,2.09,3.23,0v-18.44c0-.89-.72-1.61-1.61-1.61Z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M101.99,80.54l-18.72-6.09c-1.98-.65-2.98,2.42-1,3.07l18.72,6.09c1.91.62,2.97-2.43,1-3.07Z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M71.24,44.69c.8.51,1.55.39,2.25-.36l11.28-15.54c1.23-1.69-1.39-3.59-2.61-1.9l-11.28,15.54c-.52.72-.36,1.73.36,2.25Z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M36.65,44.34c1.27,1.75,3.81-.25,2.61-1.9l-11.28-15.54c-1.23-1.69-3.84.21-2.61,1.9l11.28,15.54Z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M26.88,74.45l-18.72,6.09c-1.96.64-.91,3.69,1,3.07l18.72-6.09c1.98-.65.99-3.72-1-3.07Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEstrella);
export default __webpack_public_path__ + "static/media/estrella.767799e3c5f36b90e6900205218908f3.svg";
export { ForwardRef as ReactComponent };